"use client";

import { useTranslations } from "next-intl";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useRouter } from "@/i18n/navigation";
import {
  BLOG_FILTERS,
  type BlogFilterKey,
  filterToQuery,
} from "@/lib/blog/filter";

interface BlogCategoryFilterProps {
  value: BlogFilterKey;
}

/**
 * Self-contained filter: owns the URL navigation so the /blog page can be a
 * pure async Server Component (which cannot pass an onChange function across
 * the client boundary). Receives only the serializable active `value`.
 */
export const BlogCategoryFilter: React.FC<BlogCategoryFilterProps> = ({
  value,
}) => {
  const t = useTranslations("blog");
  const router = useRouter();

  const onChange = (key: BlogFilterKey) => {
    const q = filterToQuery(key);
    const params = new URLSearchParams();
    if (q.category) params.set("category", q.category);
    if (q.status) params.set("status", q.status);
    const qs = params.toString();
    router.push(qs ? `/blog?${qs}` : "/blog");
  };

  return (
    <Select value={value} onValueChange={(v) => onChange(v as BlogFilterKey)}>
      <SelectTrigger className="w-full justify-between text-base font-bold">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {BLOG_FILTERS.map((f) => (
          <SelectItem
            key={f.key}
            value={f.key}
            className="justify-end text-base"
          >
            {t(`filters.${f.labelKey}`)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
